import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { TypeBookEnum } from '@app/core/models/books.model';
import { BooksService } from '@app/core/services';
import { notNull, safeEmptyList, switchDelay } from '@app/shared/utils';
import { AppSelectors } from '@app/store';
import { AppState } from '@app/store/app.state';
import { Store } from '@ngrx/store';
import { isEqual } from 'lodash';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { distinctUntilChanged, map, switchMap, tap } from 'rxjs/operators';

@Component({
  selector: 'app-card-educational-materials',
  templateUrl: './card-educational-materials.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CardEducationalMaterialsComponent implements OnInit, OnDestroy {
  private readonly store = inject<Store<AppState>>(Store);
  private readonly booksService = inject(BooksService);
  public books$: Observable<any[]>;
  public loading$: Observable<boolean>;
  private _loading$ = new BehaviorSubject(true);

  constructor() {
    this.loading$ = this._loading$.pipe(switchDelay());
  }

  public ngOnInit() {
    this.books$ = this.store.select(AppSelectors.appFeature).pipe(
      notNull(),
      map(({ usuario_ativo, funcao_padrao }) => {
        if (!!usuario_ativo) {
          return {
            entidade_id: usuario_ativo?.entidade_id,
            campo_id: usuario_ativo?.campo_id,
            uniao_id: usuario_ativo?.uniao_id,
            divisao_id: usuario_ativo?.divisao_id,
            editora_id: usuario_ativo?.editora_id,
            modelo_id: usuario_ativo?.pais_id,
            funcao_padrao,
          };
        }
        return null;
      }),
      distinctUntilChanged(isEqual),
      tap(() => this._loading$.next(true)),
      switchMap((param) => {
        if (!!param) {
          return this.listBooks(param);
        }
        return of([]);
      }),
      tap(() => this._loading$.next(false)),
    );
  }

  public ngOnDestroy() {
    this._loading$.complete();
  }

  private listBooks(param: any) {
    return this.booksService.getDashboard({ ...param, type: TypeBookEnum.Didatico }).pipe(safeEmptyList());
  }
}
